import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import { deleteStabilimento, fetchStabilimenti } from "../../../features/stabilimenti/stabilimentiThunk";
import { useEffect } from "react";
import {
  selectError,
  selectIsLoading,
  selectStabilimenti,
} from "../../../features/stabilimenti/stabilimentiSlice";
import { fetchCompanies } from "../../../features/company/companyThunk";

const Stabilimenti = () => {
  const columns = [
    { field: "nomeStabilimento", headerName: "Nome stabilimento", width: 515 },
    { field: "tipologia", headerName: "Tipologia", width: 438 },
    { field: "supTotale", headerName: "Sup. Totale (m²)", width: 140 },
    { field: "supCoperta", headerName: "Sup. coperta (m²)", width: 158 },
    { field: "stoccaggio", headerName: "Stoccaggio L/t.", width: 140 },
    { field: "impianti", headerName: "Impianti", width: 132 },
    { field: "coordinateGPS", headerName: "Coordinate GPS", width: 160 },
    { field: "azioni", headerName: "Azioni", width: 60, sortable: false },
  ];

  // stabilimenti selectors
  const stabilimenti = useSelector(selectStabilimenti) || [];
  console.log(stabilimenti, "dhdhhd");
  const stabilimentiLoading = useSelector(selectIsLoading);
  const stabilimentiError = useSelector(selectError);
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCompanies())
  },[])
  
  useEffect(() => {
    dispatch(fetchStabilimenti());
  }, [dispatch,selectSelectedCompany]);

  // Format cantines data for the table
  const formattedStabilimenti = stabilimenti.map((item) => ({
    id: item?.id || "N/A",
    nomeStabilimento: item?.nome || "N/A",
    tipologia: item?.tipologia || "N/A",
    supTotale: item?.superficie_totale || "N/A",
    supCoperta: item?.superficie_coperta || "N/A",
    stoccaggio: item?.capacita_stoccaggio || "N/A",
    impianti: item?.presenza_impianti_speciali === true
    ? "true"
    : item?.presenza_impianti_speciali === false
    ? "false"
    : "N/A",
    coordinateGPS: item?.coordinate_gps || "N/A",
    azioni: item?.region || "N/A",
  }));

  console.log("Formatted Data for Table:", formattedStabilimenti);

  return (
    <>
      <div className="pageTemplate">
        {stabilimentiLoading && <p>Loading...</p>}
        {stabilimentiError && (
          <p style={{ color: "red" }}>Error: {stabilimentiError}</p>
        )}
        <Table
          data={formattedStabilimenti?.length ? formattedStabilimenti : []}
          columns={columns}
          navData={"structureStabilimenti"}
          deleteFunctions={"deleteStabilimento"}
        />
      </div>
    </>
  );
};

export default Stabilimenti;
